export const FORM_REQUESTING = '[FORM MANAGEMENT] FORM_REQUESTING';
export const FORM_REQUEST_SUCCESS = '[FORM MANAGEMENT] FORM_REQUEST_SUCCESS';
export const FORM_REQUEST_FAILED = '[FORM MANAGEMENT] FORM_REQUEST_FAILED';
